/* Aurora 2027 — memoria de navegación (propuesta 14-10)
   Recuerda en ESTE navegador lo que la persona abre y agrega, sin cookies de terceros ni datos personales.
   Con eso: fila "Lo que estabas viendo", "Elegidos para ti", aviso de regreso y orden de la tienda. */
(function(){
"use strict";
const {A, byH, $, $$, clp, esc, img, url, card, corto, ic, wsp, Carro, toast, riel} = window.AU;
const KV = "a27-vistos", KG = "a27-gustos", KS = "a27-sesion";
const leer = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) || d; } catch(e) { return d; } };
const escribir = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} };

let vistos = leer(KV, []).filter(x => byH[x.h]);           // [{h, t}] lo más reciente primero
let gustos = leer(KG, {});                                 // {familia: puntaje}
const sumar = (p, n) => { gustos[p.f] = (gustos[p.f] || 0) + n; escribir(KG, gustos); };

/* ¿es una visita nueva? (más de 30 min desde la última actividad) */
const ahora = Date.now(), ultima = leer(KS, 0), regreso = (ultima && ahora - ultima > 30 * 60e3) || /[?&]vuelta/.test(location.search);   // ?vuelta: para mostrarlo en la propuesta
escribir(KS, ahora);

const mem = {
  vistos: (sin) => vistos.filter(x => x.h !== sin).map(x => byH[x.h]),
  famTop: () => { const rec = f => { const i = vistos.findIndex(x => byH[x.h].f === f); return i < 0 ? 99 : i; };   // empate: gana la más reciente
    return Object.entries(gustos).sort((a, b) => b[1] - a[1] || rec(a[0]) - rec(b[0])).map(x => x[0]); },
  /* empuje para el orden "Recomendados" de la tienda */
  bonus: p => (gustos[p.f] ? Math.min(gustos[p.f], 30) : 0) + (vistos.some(x => x.h === p.h) ? 12 : 0),
  vio: h => { const p = byH[h]; if (!p) return; vistos = [{h, t:ahora}, ...vistos.filter(x => x.h !== h)].slice(0, 12); escribir(KV, vistos); sumar(p, 3); },
};
window.AU.mem = mem;

/* agregar al carro pesa más que mirar */
const ag = Carro.agregar.bind(Carro);
Carro.agregar = function(h, ...r){ if (byH[h]) sumar(byH[h], 6); return ag(h, ...r); };

const page = document.body.dataset.page;
const seccion = (id, eyebrow, titulo, ps, extra = "") => `<section class="sec cont mem-sec" id="${id}" aria-labelledby="${id}-h"><div class="sec-head"><div><span class="eyebrow">${eyebrow}</span><h2 id="${id}-h" class="h2">${titulo}</h2>${extra}</div><div class="flechas"><button class="flecha" data-prev aria-label="Anterior">${ic("izq")}</button><button class="flecha" data-next aria-label="Siguiente">${ic("flecha")}</button></div></div><div class="riel-wrap"><div class="riel riel--4">${ps.map(p => card(p)).join("")}</div></div></section>`;

/* ---------- portada ---------- */
if (page === "home") {
  const hero = $(".hv2");
  const vs = mem.vistos().slice(0, 8), fams = mem.famTop();
  let html = "";
  if (vs.length) html += seccion("mem-vistos", "Para retomar", "Lo que estabas <i>viendo</i>", vs);
  if (fams.length) {
    const ya = new Set(vs.map(p => p.h));
    const ps = A.productos.filter(p => p.f === fams[0] && !ya.has(p.h)).sort((a, b) => (b.a - b.p) / (b.a || 1) - (a.a - a.p) / (a.a || 1)).slice(0, 10);
    if (ps.length >= 3) html += seccion("mem-para-ti", "Elegidos para ti", `Más de <i>${esc(fams[0].toLowerCase())}</i>`, ps, `<p class="lead">Porque estuviste mirando ${esc(fams[0].toLowerCase())}. Ordenados por mayor ahorro.</p>`);
  }
  if (html && hero) { hero.insertAdjacentHTML("afterend", html); $$(".mem-sec .riel").forEach(riel); }
  /* aviso de regreso: la última ficha que vio, con su precio de hoy */
  const u = vs[0];
  if (regreso && u) {
    document.body.insertAdjacentHTML("beforeend", `<a class="mem-vuelve" href="${url(u.h)}" data-mem-vuelve><img src="${img(u.img, 120)}" alt=""><span><small>Hola de nuevo · ¿sigues pensándolo?</small><b>${esc(corto(u.t, 44))}</b><em>${u.ses && u.ses.length > 1 ? "desde " : ""}${clp(u.p)}${u.a > u.p ? ` <s>${clp(u.a)}</s>` : ""}</em></span><button type="button" aria-label="Cerrar" data-mem-x>${ic("x")}</button></a>`);
    const b = $("[data-mem-vuelve]");
    setTimeout(() => b.classList.add("on"), 1200);
    b.querySelector("[data-mem-x]").addEventListener("click", e => { e.preventDefault(); b.classList.remove("on"); });
    /* no estorba: se va al bajar más de una pantalla o a los 12 s */
    const fuera = () => b.classList.remove("on");
    setTimeout(fuera, 13200);
    addEventListener("scroll", () => { if (scrollY > innerHeight) fuera(); }, {passive:true});
  }
}

/* ---------- ficha ---------- */
if (page === "ficha") {
  const SH = window.AU_SHOP;
  const h = SH ? SH.handle : new URLSearchParams(location.search).get("t") || "hifu-20d";
  const p = byH[h];
  if (p) {
    const antes = mem.vistos(h).slice(0, 8);
    mem.vio(h);
    /* lo que vio antes, al final de la ficha */
    addEventListener("DOMContentLoaded", () => {   // la ficha se pinta después de este archivo
      const ult = $$("[data-main] > section").pop();
      if (antes.length && ult) { ult.insertAdjacentHTML("afterend", seccion("mem-antes", "Para comparar", "Lo que viste <i>antes</i>", antes).replace(' cont mem-sec', ' sec--t mem-sec')); riel($("#mem-antes .riel")); }
    });

    /* aviso al irse: una vez por visita, solo después de 20 s mirando */
    let listo = false, mostrado = false;
    try { mostrado = sessionStorage.getItem("a27-salida") === "1"; } catch(e){}
    setTimeout(() => listo = true, 20000);
    const salida = () => {
      if (!listo || mostrado || document.documentElement.classList.contains("bv-abierto")) return;
      mostrado = true; try { sessionStorage.setItem("a27-salida", "1"); } catch(e){}
      document.body.insertAdjacentHTML("beforeend", `<div class="mem-salida" role="dialog" aria-modal="true" aria-labelledby="mem-salida-h" data-mem-salida>
        <div class="mem-salida__box"><button class="ibtn mem-salida__x" aria-label="Cerrar" data-mem-cerrar>${ic("x")}</button>
          <img src="${img(p.img, 200)}" alt="">
          <span class="eyebrow">Antes de irte</span>
          <h3 class="h3" id="mem-salida-h">Te guardamos <i>${esc(corto(p.t, 40))}</i></h3>
          <p class="muted">Déjanos tu correo y te damos un <b>5 % extra en tu primera reserva</b>, sobre el precio de hoy (${clp(p.p)}). Sin spam.</p>
          <form class="mem-salida__f" data-mem-form><label class="sr" for="mem-mail">Correo</label><input id="mem-mail" type="email" required placeholder="tu@correo.cl" autocomplete="email"><button class="btn btn--tinta">Quiero mi 5 %</button></form>
          <a class="lnk" href="${wsp("Hola Aurora, estaba viendo " + p.t + " y tengo una duda")}" target="_blank" rel="noopener">${ic("pregunta")} Prefiero preguntar por WhatsApp</a>
        </div></div>`);
      const m = $("[data-mem-salida]");
      requestAnimationFrame(() => m.classList.add("on"));
      const cerrar = () => { m.classList.remove("on"); setTimeout(() => m.remove(), 350); };
      m.addEventListener("click", e => { if (e.target === m || e.target.closest("[data-mem-cerrar]")) cerrar(); });
      m.querySelector("[data-mem-form]").addEventListener("submit", e => {
        e.preventDefault();
        const mail = m.querySelector("#mem-mail").value.trim();
        /* queda en la lista de clientes de Shopify (acepta correos), con etiqueta para medir de dónde vino */
        if (/auroraestetica\.cl$/.test(location.hostname)) {
          const fd = new FormData(); fd.append("form_type", "customer"); fd.append("utf8", "✓");
          fd.append("contact[email]", mail); fd.append("contact[tags]", "newsletter,aviso-salida," + h); fd.append("contact[accepts_marketing]", "true");
          fetch("/contact#contact_form", {method:"POST", body:fd, keepalive:true}).catch(() => {});
        }
        try { localStorage.setItem("a27-codigo", "AURORA5"); } catch(err){}
        m.querySelector(".mem-salida__box").innerHTML = `<button class="ibtn mem-salida__x" aria-label="Cerrar" data-mem-cerrar>${ic("x")}</button>
          <span class="eyebrow">Listo</span><h3 class="h3">Tu 5 % <i>ya está guardado</i></h3>
          <p class="muted">Tu código es <b class="mem-codigo">AURORA5</b>. Se aplica solo cuando vayas a pagar, en tu primera reserva.</p>
          <button class="btn btn--tinta" data-mem-cerrar>Seguir viendo ${esc(corto(p.t, 30))}</button>`;
      });
    };
    /* escritorio: el mouse sale por arriba (hacia las pestañas o la X) */
    document.addEventListener("mouseout", e => { if (!e.relatedTarget && e.clientY < 8) salida(); });
    /* celular: sube rápido hacia arriba después de haber bajado (gesto típico antes de volver atrás) */
    let y0 = scrollY, t0 = Date.now(), maxY = 0;
    addEventListener("scroll", () => {
      const y = scrollY, t = Date.now(); maxY = Math.max(maxY, y);
      if (matchMedia("(max-width:900px)").matches && maxY > innerHeight * 1.2 && y < y0 && (y0 - y) / Math.max(t - t0, 1) > 2.2 && y < innerHeight * .8) salida();
      y0 = y; t0 = t;
    }, {passive:true});
  }
}
})();
